import Lottie from 'lottie-react'
import LoaderJSON from '../../../assets/animations/loader/data.json'
import { Spin } from 'antd';
import { ANIMATION_TYPES, getAnimationData } from '../../../utils/animationUtils';

const RebetLoader = ({height, width}) => {
  const loaderAnimationData = getAnimationData(ANIMATION_TYPES.LOADING);

  if (loaderAnimationData?.id) {

  return (
    <div data-testid="rebet-loader">
      <Lottie 
      animationData={LoaderJSON} 
      loop={true} 
      style={{
        height: height, 
        width: width,
        margin: "auto"
      }}
      />
    </div>
  );
  } else {
    return (
      <div data-testid="rebet-loader">
        <Spin size="small" style={{ color: "var(--COLOR-PRIMARY)" }} />
      </div>
    )
  }
};

export default RebetLoader;